// extracted by mini-css-extract-plugin
export default {"alert":"j4VF4UqqXF7bPMsBmGEx"};